import Context from './Context.ts';
import Item from './Item/index.js';
import List from './List/index.js';
import Pane from './Pane/index.ts';
import Tabs from './Tabs.jsx';

export default Object.assign(Tabs, { Item, Pane, List, Context });
export type { TabsProps } from './Tabs.d.ts';
